var _clipPath, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _use93, _use94, _use95, _use96, _use97, _use98, _use99, _use100, _use101, _use102, _use103, _use104, _use105, _use106, _use107, _use108, _use109, _use110, _use111, _use112, _use113, _use114, _use115, _use116, _use117, _use118, _use119, _use120, _use121, _use122, _use123, _use124, _use125, _use126, _use127, _use128, _use129, _use130, _use131, _use132, _use133, _use134, _use135, _use136, _use137, _use138, _use139, _use140, _use141, _use142, _use143, _use144, _use145, _use146, _use147, _use148, _use149, _use150, _use151, _use152, _use153, _use154, _use155, _use156, _use157, _use158, _use159, _use160, _use161, _use162, _use163, _use164, _use165, _use166, _use167, _use168, _use169, _use170, _use171, _use172, _use173, _use174, _use175, _use176, _use177, _use178, _use179, _use180, _use181, _use182, _use183, _use184, _use185, _use186, _use187, _use188, _use189, _use190, _use191, _use192, _use193, _use194, _use195, _use196, _use197, _use198, _use199, _use200, _use201, _use202, _use203, _use204, _use205, _use206, _use207, _use208, _use209, _use210, _use211, _use212, _use213, _use214, _use215, _use216, _use217, _use218, _use219, _use220, _use221, _use222, _use223, _use224, _use225, _use226, _use227, _use228, _use229, _use230, _use231, _use232, _use233, _use234, _use235, _use236, _use237, _use238, _use239, _use240, _use241, _use242, _use243, _use244, _use245, _use246, _use247, _use248, _use249, _use250, _use251, _use252, _use253, _use254, _use255, _use256, _use257, _use258, _use259, _use260, _use261, _use262, _use263, _use264, _use265, _use266, _use267;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfectMagicCube5850(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "208.94pt",
    height: "226.75pt",
    viewBox: "0 0 208.94 226.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.34375 -0.515625 C 1.890625 -0.96875 2.5 -1.53125 3.328125 -2.34375 C 4.59375 -3.53125 4.796875 -3.828125 4.796875 -4.40625 C 4.796875 -5.34375 3.90625 -6.15625 2.890625 -6.15625 C 2.28125 -6.15625 1.703125 -5.875 1.3125 -5.390625 C 1.125 -5.140625 0.984375 -4.84375 0.984375 -4.65625 C 0.984375 -4.53125 1.09375 -4.421875 1.234375 -4.421875 C 1.375 -4.421875 1.453125 -4.5 1.484375 -4.65625 C 1.65625 -5.234375 2.25 -5.640625 2.890625 -5.640625 C 3.640625 -5.640625 4.265625 -5.078125 4.265625 -4.421875 C 4.265625 -4 4.09375 -3.75 3.171875 -2.84375 C 2.34375 -2.0625 1.578125 -1.359375 0.875 -0.75 L 0.78125 -0.671875 L 0.78125 0 L 4.828125 0 L 4.828125 -0.8125 C 4.828125 -1.015625 4.75 -1.125 4.578125 -1.125 C 4.40625 -1.125 4.3125 -1.015625 4.3125 -0.8125 L 4.3125 -0.515625 Z M 1.34375 -0.515625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.953125 -5.515625 L 4.3125 -5.515625 C 4.53125 -5.515625 4.640625 -5.59375 4.640625 -5.765625 C 4.640625 -5.9375 4.53125 -6.015625 4.3125 -6.015625 L 1.4375 -6.015625 L 1.4375 -3.328125 C 1.4375 -3.171875 1.53125 -3.0625 1.6875 -3.0625 C 1.75 -3.0625 1.796875 -3.078125 1.921875 -3.140625 C 2.359375 -3.359375 2.765625 -3.46875 3.171875 -3.46875 C 3.96875 -3.46875 4.515625 -2.890625 4.515625 -2.03125 C 4.515625 -1.03125 3.875 -0.359375 2.921875 -0.359375 C 2.359375 -0.359375 1.84375 -0.578125 1.375 -1.015625 C 1.28125 -1.09375 1.234375 -1.109375 1.15625 -1.109375 C 1.015625 -1.109375 0.90625 -1 0.90625 -0.859375 C 0.90625 -0.703125 1.046875 -0.5625 1.390625 -0.34375 C 1.90625 -0.015625 2.40625 0.15625 2.953125 0.15625 C 4.171875 0.15625 5.046875 -0.75 5.046875 -2.015625 C 5.046875 -3.15625 4.265625 -3.96875 3.21875 -3.96875 C 2.78125 -3.96875 2.453125 -3.890625 1.953125 -3.703125 Z M 1.953125 -5.515625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.265625 -6.125 L 1.34375 -5.515625 C 1.15625 -5.46875 1.09375 -5.40625 1.09375 -5.265625 C 1.09375 -5.125 1.21875 -5.015625 1.34375 -5.015625 C 1.359375 -5.015625 1.453125 -5.03125 1.5 -5.046875 L 2.75 -5.4375 L 2.75 -0.515625 L 1.40625 -0.515625 C 1.1875 -0.515625 1.078125 -0.421875 1.078125 -0.265625 C 1.078125 -0.09375 1.203125 0 1.40625 0 L 4.609375 0 C 4.8125 0 4.921875 -0.09375 4.921875 -0.265625 C 4.921875 -0.421875 4.8125 -0.515625 4.609375 -0.515625 L 3.265625 -0.515625 Z M 3.265625 -6.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.8125 -2.609375 C 1.8125 -2.71875 1.8125 -2.8125 1.8125 -2.859375 C 1.8125 -3.453125 1.96875 -4.046875 2.25 -4.46875 C 2.734375 -5.1875 3.5 -5.640625 4.25 -5.640625 C 4.4375 -5.640625 4.578125 -5.625 4.6875 -5.578125 C 4.78125 -5.515625 4.828125 -5.515625 4.875 -5.515625 C 5.015625 -5.515625 5.125 -5.625 5.125 -5.75 C 5.125 -5.984375 4.75 -6.15625 4.265625 -6.15625 C 3.609375 -6.15625 2.953125 -5.90625 2.421875 -5.4375 C 1.671875 -4.8125 1.3125 -3.96875 1.3125 -2.796875 C 1.3125 -1.0625 2.15625 0.15625 3.375 0.15625 C 4.375 0.15625 5.15625 -0.703125 5.15625 -1.78125 C 5.15625 -2.8125 4.375 -3.671875 3.421875 -3.671875 C 2.765625 -3.671875 2.171875 -3.28125 1.8125 -2.609375 Z M 1.890625 -1.890625 C 2.109375 -2.28125 2.21875 -2.453125 2.359375 -2.609375 C 2.6875 -2.96875 3.0625 -3.15625 3.421875 -3.15625 C 4.078125 -3.15625 4.625 -2.53125 4.625 -1.78125 C 4.625 -0.984375 4.09375 -0.359375 3.390625 -0.359375 C 2.640625 -0.359375 2.15625 -0.84375 1.890625 -1.890625 Z M 1.890625 -1.890625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.875 -3.109375 C 4.5 -3.4375 4.8125 -3.90625 4.8125 -4.484375 C 4.8125 -5.390625 3.984375 -6.15625 3 -6.15625 C 2 -6.15625 1.171875 -5.390625 1.171875 -4.484375 C 1.171875 -3.90625 1.5 -3.4375 2.125 -3.109375 C 1.453125 -2.796875 1.078125 -2.25 1.078125 -1.625 C 1.078125 -0.65625 1.9375 0.15625 3 0.15625 C 4.0625 0.15625 4.921875 -0.65625 4.921875 -1.625 C 4.921875 -2.25 4.53125 -2.8125 3.875 -3.109375 Z M 2.96875 -5.640625 C 3.71875 -5.640625 4.296875 -5.125 4.296875 -4.46875 C 4.296875 -3.84375 3.71875 -3.359375 3 -3.359375 C 2.265625 -3.359375 1.703125 -3.84375 1.703125 -4.46875 C 1.703125 -5.109375 2.28125 -5.640625 2.96875 -5.640625 Z M 2.96875 -2.859375 C 3.796875 -2.859375 4.40625 -2.34375 4.40625 -1.625 C 4.40625 -0.921875 3.78125 -0.359375 3 -0.359375 C 2.21875 -0.359375 1.59375 -0.921875 1.59375 -1.625 C 1.59375 -2.3125 2.203125 -2.859375 2.96875 -2.859375 Z M 2.96875 -2.859375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.921875 -3.5 C 4.921875 -5.078125 4.140625 -6.15625 3 -6.15625 C 1.859375 -6.15625 1.078125 -5.078125 1.078125 -3.5 L 1.078125 -2.515625 C 1.078125 -0.921875 1.859375 0.15625 3 0.15625 C 4.140625 0.15625 4.921875 -0.921875 4.921875 -2.515625 Z M 1.59375 -3.4375 C 1.59375 -4.046875 1.78125 -4.703125 2.0625 -5.15625 C 2.28125 -5.46875 2.59375 -5.640625 3 -5.640625 C 3.40625 -5.640625 3.71875 -5.46875 3.9375 -5.15625 C 4.21875 -4.703125 4.40625 -4.046875 4.40625 -3.4375 L 4.40625 -2.5625 C 4.40625 -1.953125 4.21875 -1.296875 3.9375 -0.84375 C 3.71875 -0.53125 3.390625 -0.359375 3 -0.359375 C 2.609375 -0.359375 2.28125 -0.53125 2.0625 -0.84375 C 1.78125 -1.296875 1.59375 -1.953125 1.59375 -2.5625 Z M 1.59375 -3.4375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.703125 -1.65625 L 3.703125 -0.515625 L 3 -0.515625 C 2.78125 -0.515625 2.671875 -0.421875 2.671875 -0.265625 C 2.671875 -0.09375 2.796875 0 3 0 L 4.515625 0 C 4.71875 0 4.828125 -0.09375 4.828125 -0.265625 C 4.828125 -0.421875 4.71875 -0.515625 4.515625 -0.515625 L 4.21875 -0.515625 L 4.21875 -1.65625 L 4.515625 -1.65625 C 4.71875 -1.65625 4.828125 -1.75 4.828125 -1.921875 C 4.828125 -2.078125 4.71875 -2.171875 4.515625 -2.171875 L 4.21875 -2.171875 L 4.21875 -6.015625 L 3.296875 -6.015625 L 1 -2.1875 L 1 -1.65625 Z M 3.703125 -2.171875 L 1.53125 -2.171875 L 3.546875 -5.515625 L 3.703125 -5.515625 Z M 3.703125 -2.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.640625 -3.390625 C 4.65625 -3.28125 4.65625 -3.1875 4.65625 -3.15625 C 4.65625 -2.546875 4.5 -1.953125 4.203125 -1.53125 C 3.71875 -0.8125 2.953125 -0.359375 2.203125 -0.359375 C 2.03125 -0.359375 1.875 -0.390625 1.78125 -0.4375 C 1.671875 -0.484375 1.640625 -0.5 1.578125 -0.5 C 1.4375 -0.5 1.34375 -0.390625 1.34375 -0.25 C 1.34375 -0.015625 1.703125 0.15625 2.203125 0.15625 C 2.84375 0.15625 3.5 -0.09375 4.046875 -0.5625 C 4.796875 -1.1875 5.15625 -2.03125 5.15625 -3.1875 C 5.15625 -4.9375 4.296875 -6.15625 3.078125 -6.15625 C 2.09375 -6.15625 1.3125 -5.296875 1.3125 -4.21875 C 1.3125 -3.1875 2.09375 -2.34375 3.03125 -2.34375 C 3.6875 -2.34375 4.265625 -2.71875 4.640625 -3.390625 Z M 4.578125 -4.109375 C 4.34375 -3.71875 4.234375 -3.546875 4.078125 -3.390625 C 3.78125 -3.046875 3.390625 -2.84375 3.03125 -2.84375 C 2.375 -2.84375 1.828125 -3.46875 1.828125 -4.21875 C 1.828125 -5.015625 2.359375 -5.640625 3.078125 -5.640625 C 3.828125 -5.640625 4.296875 -5.15625 4.578125 -4.109375 Z M 4.578125 -4.109375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.328125 -5.390625 L 2.71875 -0.375 C 2.703125 -0.3125 2.703125 -0.28125 2.703125 -0.234375 C 2.703125 -0.09375 2.8125 0.015625 2.953125 0.015625 C 3.078125 0.015625 3.140625 -0.046875 3.203125 -0.234375 L 4.828125 -5.328125 L 4.828125 -6.015625 L 1 -6.015625 L 1 -5.21875 C 1 -5 1.09375 -4.890625 1.265625 -4.890625 C 1.421875 -4.890625 1.515625 -5 1.515625 -5.21875 L 1.515625 -5.515625 L 4.328125 -5.515625 Z M 4.328125 -5.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.78125 -3.5625 C 2.578125 -3.5625 2.46875 -3.46875 2.46875 -3.3125 C 2.46875 -3.140625 2.578125 -3.0625 2.78125 -3.0625 C 3.75 -3.03125 4.515625 -2.4375 4.515625 -1.6875 C 4.515625 -0.96875 3.78125 -0.359375 2.90625 -0.359375 C 2.34375 -0.359375 1.84375 -0.546875 1.359375 -0.890625 C 1.265625 -0.953125 1.21875 -0.96875 1.140625 -0.96875 C 1.015625 -0.96875 0.90625 -0.859375 0.90625 -0.734375 C 0.90625 -0.5625 1.03125 -0.4375 1.390625 -0.265625 C 1.921875 0.015625 2.390625 0.15625 2.890625 0.15625 C 4.078125 0.15625 5.03125 -0.671875 5.03125 -1.6875 C 5.03125 -2.34375 4.578125 -2.953125 3.875 -3.265625 C 4.484375 -3.546875 4.828125 -4.03125 4.828125 -4.578125 C 4.828125 -5.46875 4.03125 -6.15625 3 -6.15625 C 2.46875 -6.15625 1.96875 -5.984375 1.5625 -5.6875 C 1.34375 -5.515625 1.203125 -5.34375 1.203125 -5.21875 C 1.203125 -5.09375 1.3125 -4.984375 1.453125 -4.984375 C 1.53125 -4.984375 1.59375 -5.015625 1.640625 -5.078125 C 2 -5.46875 2.40625 -5.640625 3 -5.640625 C 3.75 -5.640625 4.296875 -5.1875 4.296875 -4.578125 C 4.296875 -4.265625 4.125 -3.953125 3.828125 -3.765625 C 3.59375 -3.609375 3.390625 -3.5625 3 -3.5625 Z M 2.78125 -3.5625 "
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 195 29 L 208.796875 29 L 208.796875 36 L 195 36 Z M 195 29 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 882.073691 1214.973643 L 848.28648 2220.807952 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 226.977219 545.290794 L 882.073691 1214.973643 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 882.073691 1214.973643 L 1901.594949 881.637783 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1119.874649 1137.231774 L 1123.120411 2156.713926 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 494.224669 434.270087 L 1119.874649 1137.231774 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 190.569935 787.667103 L 874.526316 1440.182607 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 874.526316 1440.182607 L 1932.253714 1116.505823 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 738.986418 1068.679713 L 680.21075 2099.815325 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 738.986418 1068.679713 L 1791.278142 705.271672 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1368.546954 1055.931298 L 1412.540718 2089.217716 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 776.175813 317.109806 L 1368.546954 1055.931298 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 468.258572 678.64078 L 1120.617654 1364.904389 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 983.63085 984.172581 L 964.234489 2029.229775 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1628.833614 970.798477 L 1717.79878 2018.006477 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1074.082029 193.379789 L 1628.833614 970.798477 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 150.916889 1051.199525 L 866.392358 1681.659489 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 866.392358 1681.659489 L 1965.37613 1370.027219 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 725.886053 1298.385819 L 1819.00399 944.324008 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 761.902281 563.357566 L 1378.362452 1286.028459 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 583.307153 909.520052 L 494.811253 1966.426233 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 583.307153 909.520052 L 1670.285515 511.777322 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1240.006953 895.637576 L 1264.174194 1954.694563 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1901.594949 881.637783 L 2040.185081 1942.845576 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1389.272905 62.415243 L 1901.594949 881.637783 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 439.946141 944.949697 L 1121.36066 1609.353294 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1072.908862 441.230878 L 1648.581925 1203.320183 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 107.705237 1338.742765 L 857.671816 1941.164037 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 857.671816 1941.164037 L 2001.235936 1644.58741 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 835.186115 817.348229 L 788.572278 1888.254203 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1508.935943 802.761852 L 1581.359454 1875.818633 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 711.808049 1545.41569 L 1849.076171 1203.398394 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 746.299159 832.325662 L 1388.88185 1533.488492 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 563.715263 1143.684192 L 1694.296334 754.779321 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 413.315249 735.774015 L 289.3506 1818.568082 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 413.315249 735.774015 L 1536.935529 298.534661 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1402.842537 311.713237 L 1932.253714 1116.505823 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 408.935426 1236.286177 L 1122.220983 1872.533765 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1099.65707 720.561949 L 1099.65707 1805.506822 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1791.278142 705.271672 L 1917.354493 1792.328246 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1071.618378 712.740835 L 1669.89446 1453.830451 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 60.348394 1653.738113 L 848.28648 2220.807952 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 848.28648 2220.807952 L 2040.185081 1942.845576 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 696.595983 1811.763713 L 1881.729321 1485.036694 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 672.741586 634.803439 L 593.279072 1731.558193 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 729.170921 1127.377171 L 1400.222464 1800.423098 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1377.697657 618.848367 L 1429.668957 1717.714822 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 542.520045 1396.267055 L 1720.457959 1019.132959 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 386.019563 974.161556 L 1556.331891 545.017055 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1417.780864 585.491318 L 1965.37613 1370.027219 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 374.913582 1556.326144 L 1123.120411 2156.713926 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 226.977219 545.290794 L 60.348394 1653.738113 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 226.977219 545.290794 L 1389.272905 62.415243 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 945.737555 528.592716 L 916.212851 1639.151736 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1070.210577 1011.390057 L 1692.849428 1724.558297 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1670.285515 511.777322 L 1780.328583 1624.408937 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 680.21075 2099.815325 L 1917.354493 1792.328246 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 710.322037 1452.461756 L 1412.540718 2089.217716 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 519.682394 1669.654079 L 1749.005023 1307.849366 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 494.224669 434.270087 L 374.913582 1556.326144 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1233.398112 416.633476 L 1259.872581 1540.762128 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 356.455754 1232.297409 L 1577.527109 814.415311 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1434.205203 887.620934 L 2001.235936 1644.58741 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 190.569935 787.667103 L 1402.842537 311.713237 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1068.68546 1341.480154 L 1717.79878 2018.006477 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 776.175813 317.109806 L 710.322037 1452.461756 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1536.935529 298.534661 L 1626.448174 1435.880995 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 494.811253 1966.426233 L 1780.328583 1624.408937 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 324.350083 1512.762541 L 1600.794921 1110.014299 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1452.428397 1222.638334 L 2040.185081 1942.845576 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1074.082029 193.379789 L 1068.68546 1341.480154 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 150.916889 1051.199525 L 1417.780864 585.491318 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1389.272905 62.415243 L 1452.428397 1222.638334 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 289.3506 1818.568082 L 1626.448174 1435.880995 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 107.705237 1338.742765 L 1434.205203 887.620934 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(69.921875%,69.921875%,69.921875%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 60.348394 1653.738113 L 1452.428397 1222.638334 ",
    transform: "matrix(0.0998899,0,0,-0.0998899,0.0850881,226.500275)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 16.864588,
    y: 175.013641
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 22.85798,
    y: 175.013641
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 13.02663,
    y: 150.800537
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 19.020022,
    y: 150.800537
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 9.182818,
    y: 124.478358
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 15.17621,
    y: 124.478358
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 1.911534,
    y: 95.756125
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 7.904926,
    y: 95.756125
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 13.898319,
    y: 95.756125
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 0.0194804,
    y: 64.292415
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 6.012873,
    y: 64.292415
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 32.33585,
    y: 155.971036
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 38.329243,
    y: 155.971036
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 44.322635,
    y: 155.971036
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 32.551629,
    y: 132.173874
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 38.545021,
    y: 132.173874
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 32.793939,
    y: 106.397593
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 29.502648,
    y: 78.431926
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 22.939185,
    y: 47.826969
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 28.932577,
    y: 47.826969
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 52.455841,
    y: 138.703774
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 58.449234,
    y: 138.703774
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 47.417646,
    y: 115.300277
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 53.411038,
    y: 115.300277
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 59.40443,
    y: 115.300277
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 48.240567,
    y: 90.007863
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 54.233959,
    y: 90.007863
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 49.201227,
    y: 62.776587
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 43.512189,
    y: 32.992225
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 49.505581,
    y: 32.992225
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 67.694128,
    y: 122.731984
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 73.68752,
    y: 122.731984
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 66.698741,
    y: 99.854906
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 72.692133,
    y: 99.854906
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 65.397046,
    y: 75.18091
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 71.390438,
    y: 75.18091
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 60.738902,
    y: 48.505221
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 66.732294,
    y: 48.505221
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 72.725686,
    y: 48.505221
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 62.090931,
    y: 19.731046
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 68.084324,
    y: 19.731046
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 82.148517,
    y: 108.117197
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 88.141909,
    y: 108.117197
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 81.462945,
    y: 85.621699
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 87.456337,
    y: 85.621699
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 77.539541,
    y: 61.502591
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 83.532933,
    y: 61.502591
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 89.526325,
    y: 61.502591
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 76.669406,
    y: 35.580771
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 82.662798,
    y: 35.580771
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 88.65619,
    y: 35.580771
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 81.8629,
    y: 7.581541
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 43.362373,
    y: 186.103814
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 49.355765,
    y: 186.103814
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 40.964627,
    y: 161.698322
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 46.958019,
    y: 161.698322
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 38.090845,
    y: 135.145198
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 44.084237,
    y: 135.145198
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 37.724843,
    y: 105.991041
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 31.597618,
    y: 74.022388
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 37.59101,
    y: 74.022388
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 61.435022,
    y: 166.070501
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 67.428414,
    y: 166.070501
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 59.496529,
    y: 142.037199
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 65.489921,
    y: 142.037199
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 54.723272,
    y: 116.011194
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 60.716664,
    y: 116.011194
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 66.710056,
    y: 116.011194
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 55.391676,
    y: 87.558164
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 61.385068,
    y: 87.558164
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 53.316234,
    y: 56.517787
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 59.309626,
    y: 56.517787
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 77.61794,
    y: 147.837804
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 83.611332,
    y: 147.837804
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 73.508411,
    y: 124.217346
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 79.501803,
    y: 124.217346
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 85.495195,
    y: 124.217346
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 75.537424,
    y: 98.755618
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 81.530816,
    y: 98.755618
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 71.137585,
    y: 70.992528
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 77.130977,
    y: 70.992528
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 83.124369,
    y: 70.992528
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 72.966039,
    y: 40.864046
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 78.959431,
    y: 40.864046
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 92.392621,
    y: 131.174276
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 98.386013,
    y: 131.174276
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 91.902927,
    y: 107.985742
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 97.896319,
    y: 107.985742
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 91.398405,
    y: 83.009379
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 97.391797,
    y: 83.009379
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 91.051521,
    y: 56.035619
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 97.044913,
    y: 56.035619
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 87.472268,
    y: 26.840807
  })), _use94 || (_use94 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 93.46566,
    y: 26.840807
  })), _use95 || (_use95 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 99.459052,
    y: 26.840807
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use96 || (_use96 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 102.860402,
    y: 115.883634
  })), _use97 || (_use97 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 108.853794,
    y: 115.883634
  })), _use98 || (_use98 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 114.847186,
    y: 115.883634
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use99 || (_use99 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 106.087314,
    y: 93.198445
  })), _use100 || (_use100 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 112.080706,
    y: 93.198445
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use101 || (_use101 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 106.164572,
    y: 68.783564
  })), _use102 || (_use102 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 112.157965,
    y: 68.783564
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use103 || (_use103 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 106.188765,
    y: 42.433316
  })), _use104 || (_use104 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 112.182157,
    y: 42.433316
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,0%)",
      fillOpacity: 1
    }
  }, _use105 || (_use105 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 106.11931,
    y: 14.047013
  })), _use106 || (_use106 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 112.112702,
    y: 14.047013
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use107 || (_use107 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 71.723304,
    y: 197.810806
  })), _use108 || (_use108 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 77.716696,
    y: 197.810806
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use109 || (_use109 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 70.100094,
    y: 173.208631
  })), _use110 || (_use110 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 76.093486,
    y: 173.208631
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use111 || (_use111 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 68.634909,
    y: 146.275426
  })), _use112 || (_use112 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 74.628302,
    y: 146.275426
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use113 || (_use113 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 66.869276,
    y: 116.868348
  })), _use114 || (_use114 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 72.862668,
    y: 116.868348
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use115 || (_use115 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 64.945227,
    y: 84.39675
  })), _use116 || (_use116 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 70.93862,
    y: 84.39675
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use117 || (_use117 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 85.624028,
    y: 176.680503
  })), _use118 || (_use118 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 91.61742,
    y: 176.680503
  })), _use119 || (_use119 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 97.610813,
    y: 176.680503
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use120 || (_use120 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 87.916421,
    y: 152.436533
  })), _use121 || (_use121 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 93.909813,
    y: 152.436533
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use122 || (_use122 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 87.314351,
    y: 126.070303
  })), _use123 || (_use123 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 93.307743,
    y: 126.070303
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use124 || (_use124 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 86.494161,
    y: 97.289934
  })), _use125 || (_use125 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 92.487553,
    y: 97.289934
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use126 || (_use126 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 85.556132,
    y: 65.748909
  })), _use127 || (_use127 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 91.549524,
    y: 65.748909
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use128 || (_use128 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 103.837576,
    y: 157.504745
  })), _use129 || (_use129 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 109.830968,
    y: 157.504745
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use130 || (_use130 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 103.838357,
    y: 133.657238
  })), _use131 || (_use131 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 109.831749,
    y: 133.657238
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use132 || (_use132 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 103.783729,
    y: 107.825219
  })), _use133 || (_use133 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 109.777121,
    y: 107.825219
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use134 || (_use134 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 104.036576,
    y: 79.751871
  })), _use135 || (_use135 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 110.029968,
    y: 79.751871
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use136 || (_use136 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 104.081058,
    y: 49.130931
  })), _use137 || (_use137 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 110.07445,
    y: 49.130931
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use138 || (_use138 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 118.100801,
    y: 140.017026
  })), _use139 || (_use139 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 124.094193,
    y: 140.017026
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use140 || (_use140 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 118.337648,
    y: 116.592852
  })), _use141 || (_use141 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 124.331041,
    y: 116.592852
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use142 || (_use142 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 119.082141,
    y: 91.313723
  })), _use143 || (_use143 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 125.075533,
    y: 91.313723
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use144 || (_use144 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 119.653386,
    y: 63.948195
  })), _use145 || (_use145 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 125.646778,
    y: 63.948195
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use146 || (_use146 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 120.269504,
    y: 34.228662
  })), _use147 || (_use147 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 126.262896,
    y: 34.228662
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use148 || (_use148 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 130.850837,
    y: 124.00468
  })), _use149 || (_use149 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 136.844229,
    y: 124.00468
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use150 || (_use150 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 131.873929,
    y: 101.022619
  })), _use151 || (_use151 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 137.867321,
    y: 101.022619
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use152 || (_use152 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 132.841222,
    y: 76.300676
  })), _use153 || (_use153 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 138.834614,
    y: 76.300676
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use154 || (_use154 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 133.802271,
    y: 49.636274
  })), _use155 || (_use155 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 139.795663,
    y: 49.636274
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use156 || (_use156 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 135.130497,
    y: 20.791077
  })), _use157 || (_use157 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 141.123889,
    y: 20.791077
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use158 || (_use158 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 101.480296,
    y: 210.166284
  })), _use159 || (_use159 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 107.473688,
    y: 210.166284
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use160 || (_use160 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 101.309001,
    y: 185.406882
  })), _use161 || (_use161 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 107.302393,
    y: 185.406882
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use162 || (_use162 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 98.199539,
    y: 158.361701
  })), _use163 || (_use163 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 104.192931,
    y: 158.361701
  })), _use164 || (_use164 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 110.186324,
    y: 158.361701
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use165 || (_use165 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 97.90065,
    y: 128.455174
  })), _use166 || (_use166 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 103.894042,
    y: 128.455174
  })), _use167 || (_use167 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 109.887434,
    y: 128.455174
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use168 || (_use168 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 100.85755,
    y: 95.480629
  })), _use169 || (_use169 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 106.850942,
    y: 95.480629
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use170 || (_use170 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 117.354961,
    y: 187.936893
  })), _use171 || (_use171 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 123.348353,
    y: 187.936893
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use172 || (_use172 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 117.930889,
    y: 163.422521
  })), _use173 || (_use173 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 123.924281,
    y: 163.422521
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use174 || (_use174 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 118.643384,
    y: 136.778896
  })), _use175 || (_use175 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 124.636776,
    y: 136.778896
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use176 || (_use176 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 119.245455,
    y: 107.620445
  })), _use177 || (_use177 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 125.238847,
    y: 107.620445
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use178 || (_use178 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 116.959695,
    y: 75.574576
  })), _use179 || (_use179 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 122.953087,
    y: 75.574576
  })), _use180 || (_use180 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 128.946479,
    y: 75.574576
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use181 || (_use181 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 128.671382,
    y: 167.666741
  })), _use182 || (_use182 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 134.664774,
    y: 167.666741
  })), _use183 || (_use183 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 140.658166,
    y: 167.666741
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use184 || (_use184 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 135.886088,
    y: 143.599876
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use185 || (_use185 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 131.038302,
    y: 117.475579
  })), _use186 || (_use186 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 137.031695,
    y: 117.475579
  })), _use187 || (_use187 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 143.025087,
    y: 117.475579
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use188 || (_use188 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 138.437565,
    y: 89.018654
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use189 || (_use189 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 136.685586,
    y: 57.900962
  })), _use190 || (_use190 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 142.678978,
    y: 57.900962
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use191 || (_use191 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 141.781528,
    y: 149.293998
  })), _use192 || (_use192 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 147.77492,
    y: 149.293998
  })), _use193 || (_use193 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 153.768312,
    y: 149.293998
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use194 || (_use194 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 146.557902,
    y: 125.57445
  })), _use195 || (_use195 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 152.551294,
    y: 125.57445
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use196 || (_use196 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 150.924567,
    y: 100.056884
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use197 || (_use197 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 149.961176,
    y: 72.308977
  })), _use198 || (_use198 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 155.954568,
    y: 72.308977
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use199 || (_use199 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 152.153289,
    y: 42.111071
  })), _use200 || (_use200 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 158.146682,
    y: 42.111071
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use201 || (_use201 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 156.779439,
    y: 132.507506
  })), _use202 || (_use202 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 162.772831,
    y: 132.507506
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use203 || (_use203 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 155.787174,
    y: 109.283911
  })), _use204 || (_use204 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 161.780566,
    y: 109.283911
  })), _use205 || (_use205 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 167.773958,
    y: 109.283911
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use206 || (_use206 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 160.934229,
    y: 84.195172
  })), _use207 || (_use207 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 166.927621,
    y: 84.195172
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use208 || (_use208 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 163.130248,
    y: 57.216717
  })), _use209 || (_use209 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 169.12364,
    y: 57.216717
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use210 || (_use210 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 165.720752,
    y: 27.902137
  })), _use211 || (_use211 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 171.714144,
    y: 27.902137
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use212 || (_use212 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 129.885978,
    y: 223.32136
  })), _use213 || (_use213 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 135.87937,
    y: 223.32136
  })), _use214 || (_use214 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 141.872762,
    y: 223.32136
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use215 || (_use215 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 131.240345,
    y: 198.345797
  })), _use216 || (_use216 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 137.233737,
    y: 198.345797
  })), _use217 || (_use217 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 143.227129,
    y: 198.345797
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use218 || (_use218 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 138.807781,
    y: 171.002544
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use219 || (_use219 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 137.513119,
    y: 140.818622
  })), _use220 || (_use220 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 143.506511,
    y: 140.818622
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use221 || (_use221 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 139.160133,
    y: 107.351621
  })), _use222 || (_use222 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 145.153525,
    y: 107.351621
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use223 || (_use223 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 147.660531,
    y: 199.662745
  })), _use224 || (_use224 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 153.653923,
    y: 199.662745
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use225 || (_use225 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 149.713737,
    y: 175.038694
  })), _use226 || (_use226 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 155.707129,
    y: 175.038694
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use227 || (_use227 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 148.734739,
    y: 148.206177
  })), _use228 || (_use228 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 154.728131,
    y: 148.206177
  })), _use229 || (_use229 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 160.721523,
    y: 148.206177
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use230 || (_use230 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 150.952603,
    y: 118.604414
  })), _use231 || (_use231 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 156.945995,
    y: 118.604414
  })), _use232 || (_use232 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 162.939387,
    y: 118.604414
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use233 || (_use233 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 156.571798,
    y: 86.112937
  })), _use234 || (_use234 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 162.56519,
    y: 86.112937
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use235 || (_use235 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 161.036016,
    y: 178.347945
  })), _use236 || (_use236 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 167.029408,
    y: 178.347945
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use237 || (_use237 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 163.29095,
    y: 154.074308
  })), _use238 || (_use238 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 169.284342,
    y: 154.074308
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use239 || (_use239 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 166.003589,
    y: 127.738544
  })), _use240 || (_use240 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 171.996981,
    y: 127.738544
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use241 || (_use241 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 165.861558,
    y: 98.914423
  })), _use242 || (_use242 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 171.85495,
    y: 98.914423
  })), _use243 || (_use243 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 177.848342,
    y: 98.914423
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use244 || (_use244 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 171.986055,
    y: 67.220067
  })), _use245 || (_use245 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 177.979447,
    y: 67.220067
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use246 || (_use246 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 173.077042,
    y: 159.034439
  })), _use247 || (_use247 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 179.070434,
    y: 159.034439
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use248 || (_use248 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 175.937169,
    y: 135.089339
  })), _use249 || (_use249 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 181.930561,
    y: 135.089339
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use250 || (_use250 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 178.579955,
    y: 109.2752
  })), _use251 || (_use251 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 184.573347,
    y: 109.2752
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use252 || (_use252 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 182.259099,
    y: 81.217834
  })), _use253 || (_use253 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 188.252491,
    y: 81.217834
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use254 || (_use254 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 185.516058,
    y: 50.447859
  })), _use255 || (_use255 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 191.50945,
    y: 50.447859
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use256 || (_use256 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 184.02629,
    y: 141.415165
  })), _use257 || (_use257 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 190.019682,
    y: 141.415165
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use258 || (_use258 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 184.123059,
    y: 117.95553
  })), _use259 || (_use259 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 190.116451,
    y: 117.95553
  })), _use260 || (_use260 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 196.109843,
    y: 117.95553
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use261 || (_use261 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 190.352131,
    y: 92.630352
  })), _use262 || (_use262 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 196.345523,
    y: 92.630352
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use263 || (_use263 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 194.19828,
    y: 65.280406
  })), _use264 || (_use264 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 200.191672,
    y: 65.280406
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use265 || (_use265 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 194.904533,
    y: 35.411737
  })), _use266 || (_use266 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 200.897925,
    y: 35.411737
  })), _use267 || (_use267 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 206.891317,
    y: 35.411737
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectMagicCube5850);
export default __webpack_public_path__ + "static/media/PerfectMagicCube5_850.dbdeda8b723874923522d26f7963bc1d.svg";
export { ForwardRef as ReactComponent };